import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useState } from 'react';
import Trigger from '@magento/venia-ui/lib/components/Trigger';
import { SidebarIcon } from 'src/components';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';
import CategoryFilterModal from './categoryFilterModal';
import CategoryFilterForm from './categoryFilterForm';
import classes from './categoryFilter.module.css';

var CategoryFilter = function CategoryFilter(_ref) {
  var subCategories = _ref.subCategories,
      handleCheckboxClick = _ref.handleCheckboxClick,
      resetSelectedSubcategories = _ref.resetSelectedSubcategories,
      selectedSubcategories = _ref.selectedSubcategories,
      loggedNotConsumer = _ref.loggedNotConsumer,
      subcategoryVideoTutorials = _ref.subcategoryVideoTutorials;

  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isSmallDevice = innerWidth < 640;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpenFilters = _useState2[0],
      setIsOpenFilters = _useState2[1];

  var toggleModal = useCallback(function () {
    return setIsOpenFilters(function (prevState) {
      return !prevState;
    });
  }, []);

  if (isSmallDevice) {
    var toggleSidebarIcon = React.createElement(Trigger, {
      action: toggleModal,
      classes: {
        root: classes.triggerIconRoot
      },
      "aria-label": "Toggle sidebar"
    }, React.createElement("span", {
      className: "sr-only"
    }, "Toggle sidebar"), React.createElement(SidebarIcon, null));
    return React.createElement("div", {
      className: "col-span-12 pt-4"
    }, React.createElement("h6", {
      className: "md_mb-6 flex items-center"
    }, "Refine Categories ", toggleSidebarIcon), React.createElement("div", {
      className: "w-full h-[1px] mb-6 mt-3 bg-snowbound"
    }), React.createElement(CategoryFilterModal, {
      isOpen: isOpenFilters,
      toggleModal: toggleModal,
      subCategories: subCategories,
      handleCheckboxClick: handleCheckboxClick,
      selectedSubcategories: selectedSubcategories,
      resetSelectedSubcategories: resetSelectedSubcategories
    }));
  } else {
    return React.createElement("div", {
      className: "col-span-3 pt-14 pb-14"
    }, React.createElement("h6", {
      className: "mb-7"
    }, "Refine Categories"), React.createElement(CategoryFilterForm, {
      subCategories: subCategories,
      handleCheckboxClick: handleCheckboxClick,
      selectedSubcategories: selectedSubcategories,
      loggedNotConsumer: loggedNotConsumer,
      subcategoryVideoTutorials: subcategoryVideoTutorials
    }));
  }
};

export default CategoryFilter;